export default __webpack_public_path__ + "static/media/image3.464a3040.png";